import script from "./my-mask.vue?vue&type=script&setup=true&lang=js"
export * from "./my-mask.vue?vue&type=script&setup=true&lang=js"

import "./my-mask.vue?vue&type=style&index=0&id=82c3a0b0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82c3a0b0"]])

export default __exports__